// components/Toast.jsx
import { useEffect } from "react";
import { CheckCircle, XCircle, AlertCircle, Info, X } from "lucide-react";

export const Toast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const toastConfig = {
    success: {
      bg: "bg-emerald-900/90 border-emerald-400",
      text: "text-emerald-100",
      icon: <CheckCircle className="w-5 h-5 text-emerald-400" />,
      close: "text-emerald-300 hover:bg-emerald-800",
      border: "border-l-4 border-emerald-400",
    },
    error: {
      bg: "bg-rose-900/90 border-rose-400",
      text: "text-rose-100",
      icon: <XCircle className="w-5 h-5 text-rose-400" />,
      close: "text-rose-300 hover:bg-rose-800",
      border: "border-l-4 border-rose-400",
    },
    warning: {
      bg: "bg-amber-900/90 border-amber-400",
      text: "text-amber-100",
      icon: <AlertCircle className="w-5 h-5 text-amber-400" />,
      close: "text-amber-300 hover:bg-amber-800",
      border: "border-l-4 border-amber-400",
    },
    info: {
      bg: "bg-blue-900/90 border-blue-400",
      text: "text-blue-100",
      icon: <Info className="w-5 h-5 text-blue-400" />,
      close: "text-blue-300 hover:bg-blue-800",
      border: "border-l-4 border-blue-400",
    },
  };

  return (
    <div className="fixed top-4 right-4 flex items-start justify-end pointer-events-none z-50">
      <div
        className={`${toastConfig[type].bg} ${toastConfig[type].text} ${toastConfig[type].border} px-4 py-3 rounded-r-lg shadow-lg flex items-start space-x-3 animate-fade-in-up max-w-md w-full pointer-events-auto backdrop-blur-sm`}
        style={{
          boxShadow: "0 0 15px rgba(255, 255, 255, 0.2)",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          borderRight: "1px solid rgba(255, 255, 255, 0.1)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        }}
        role="alert"
      >
        <div className="flex-shrink-0 pt-0.5">
          {toastConfig[type].icon}
        </div>
        <div className="flex-1">
          <p className="font-medium">{message}</p>
        </div>
        <button
          onClick={onClose}
          className={`${toastConfig[type].close} p-1 rounded-full transition-colors`}
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};